import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import type {
  EnhancedAnsweringServiceType,
  IUserSearchForMLSStaffResponse,
} from '@/app-package';

type AnsweringServiceTypeTagProps = {
  answeringServiceType: IUserSearchForMLSStaffResponse['users'][0]['answeringServiceType'];
};

const AnsweringServiceTypeTag: React.FC<AnsweringServiceTypeTagProps> = ({
  answeringServiceType,
}) => {
  const labelMap: Record<EnhancedAnsweringServiceType, string> = {
    LiveConciergePlus: 'Live Concierge Plus',
    AppointmentDesk: 'Appt Desk Only',
    on: 'On',
    ns: 'N/S',
  };
  const colorMap: Record<EnhancedAnsweringServiceType, string> = {
    LiveConciergePlus: 'green',
    AppointmentDesk: 'blue',
    on: 'green',
    ns: 'red',
  };

  if (!answeringServiceType) return null;

  return (
    <StyledTag color={colorMap[answeringServiceType]}>
      {labelMap[answeringServiceType]}
    </StyledTag>
  );
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default AnsweringServiceTypeTag;
